export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
export const COUNTRY = process.env.NEXT_PUBLIC_COUNTRY as 'cn' | 'kr';
export const COA_ROOT_DOMAIN = process.env.NEXT_PUBLIC_COA_ROOT_DOMAIN;
export const CURRENCY = process.env.NEXT_PUBLIC_CURRENCY;
export const FEEDBACK_FORM_ID = process.env.NEXT_PUBLIC_FEEDBACK_FORM_ID;

export const LINKS = {
  homepage: DOMAIN,
  login: `${DOMAIN}/auth/login`,
  logout: `${DOMAIN}/auth/logout`,
  registration: `${DOMAIN}/auth/create-account`,
  myAccount: `${DOMAIN}/store/v2/account-center/my-account/profile`,
  organization: `${DOMAIN}/store/v2/accounts/registration`,
  accountDashboard: `${DOMAIN}/store/v2/accounts/dashboard`,
  psysReturnURL: `${DOMAIN}/apac/payment-history/success`,
  psys: process.env.NEXT_PUBLIC_PSYS_LINK,
  googlePrivacy: 'https://policies.google.com/privacy',
  googleTerms: 'https://policies.google.com/terms',
  'af-doc-ref-trms-and-cndts': `${DOMAIN}/apac/docs/af-doc-ref-trms-and-cndts`,
  termsAndConditions: (lang) => `${DOMAIN}/${COUNTRY}/${lang}/home/support/terms-and-conditions.html`,
  documentSearch: `${DOMAIN}/apac/document-search`,
  support: (lang) => `${DOMAIN}/${COUNTRY}/${lang}/home/support.html`,
  contactUs: (lang) => `${DOMAIN}/${COUNTRY}/${lang}/home/support/contact-us.html`,
  alphaLink: `https://www.alfa.co.kr/AlfaAesarApp/faces/oracle/webcenter/portalapp/pages/myaccount/AfMyAccPaymentPage.jspx`,
  deliveryDetailPage: `${DOMAIN}/apac/order/delivery`,
};

export const QUOTATION_EMAIl = 'chem.kr@thermofisher.com';
export const SEARCH_RESULT_GROUP_JOIN_KEY = 'ĉ';
export const SEARCH_RESULT_ITEM_JOIN_KEY = 'þ';

export const ORDER_SOURCE = [
  { label: 'WEB', value: 'WEB' },
  { label: 'Offline', value: 'Offline' },
];

const ORDER_STATUS_ENUM = {
  cn: [
    { key: 'pending.address.validation', value: 'Pending Address Validation' },
    { key: 'pending.review', value: 'Pending Review' },
    { key: 'pending.review-e1', value: 'Pending Review - E1' },
    { key: 'submitted', value: 'Submitted' },
    { key: 'order.on.hold', value: 'Order On Hold' },
    { key: 'back.order', value: 'Back Order' },
    { key: 'order.picking', value: 'Order Picking' },
    { key: 'shipped', value: 'Shipped' },
    { key: 'cancelled', value: 'Cancelled' },
    { key: 'completed', value: 'Completed' },
    { key: 'in.progress', value: 'In Progress' },
  ],
  kr: [
    { key: 'pending.address.validation', value: 'Pending Address Validation' },
    { key: 'pending.review', value: 'Pending Review' },
    { key: 'pending.review-e1', value: 'Pending Review - E1' },
    { key: 'submitted', value: 'Submitted' },
    { key: 'delivery.preparing', value: 'Delivery Preparing' },
    { key: 'shipped', value: 'Shipped' },
    { key: 'order.received', value: 'Order Received' },
    { key: 'cancelled', value: 'Cancelled' },
  ],
};
export const ORDER_STATUS = ORDER_STATUS_ENUM[COUNTRY];

export const ADMIN_HEADER_MENU_ITEMS = [
  {
    id: 0,
    link: '/store/admin/',
    title: 'Customer Service Management Portal',
  },
];

export const REGEX = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  NUMBER: /^[0-9]*$/,
  DECIMAL: /^\d+(\.\d{1,2})?$/,
};

export const mapOrderStatusKey = (status: string) => {
  const statusObj = ORDER_STATUS.find((item) => item.value === status);
  return statusObj ? statusObj.key : status;
};

export const ErrorMessageWhiteList = [
  '/api/recommended/search',
  '/service/coa',
  '/api/document/search/sds',
  '/api/document/search/specification',
];
